// extracted by mini-css-extract-plugin
export default {"deskTopWrapper":"About_deskTopWrapper__LpTVm","deskTopContent":"About_deskTopContent__5zF-D","responsiveWrapper":"About_responsiveWrapper__K3K-1","mobileBG":"About_mobileBG__vooI9"};